import * as Yup from "yup";

// Common validation patterns
export const phoneRegExp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
export const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// Common validation schemas
export const phoneValidation = Yup.string()
  .required("Required")
  .matches(phoneRegExp, "Invalid phone number");

export const emailValidation = Yup.string()
  .required("Required")
  .email("Invalid email address");

export const requiredValidation = Yup.string().required("Required");

export const optionalEmailValidation = Yup.string()
  .email("Invalid email address")
  .optional();

// Company validation schema
export const companyValidationSchema = Yup.object().shape({
  phone: phoneValidation,
  contactEmail: emailValidation,
  line1: requiredValidation,
  line2: Yup.string().optional(),
  line3: Yup.string().optional(),
  town: requiredValidation,
  country: requiredValidation,
  postcode: requiredValidation,
  website: Yup.string().url("Invalid URL").optional(),
  invitationEmail: emailValidation,
});

// User validation schema
export const userValidationSchema = Yup.object().shape({
  firstName: requiredValidation,
  lastName: requiredValidation,
  email: emailValidation,
  phone: phoneValidation.optional(),
});

// Password validation schema
export const passwordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});

// Address validation schema
export const addressValidationSchema = Yup.object().shape({
  line1: requiredValidation,
  line2: Yup.string().optional(),
  line3: Yup.string().optional(),
  town: requiredValidation,
  country: requiredValidation,
  postcode: requiredValidation,
}); 
